import email from "../../assets/svg-icons/contact/email.svg";
import phone from "../../assets/svg-icons/contact/phone.svg";
import telegram from "../../assets/svg-icons/contact/telegram.svg";
import whatsapp from "../../assets/svg-icons/contact/wa.svg";

const contactData = [
    {
        id: "c_1",
        title: "email",
        link: "#",
        icon: email
    },
    {
        id: "c_2",
        title: "phone",
        link: "#",
        icon: phone
    },
    {
        id: "c_3",
        title: "telegram",
        link: "#",
        icon: telegram
    },
    {
        id: "c_4",
        title: "whatsapp",
        link: "#",
        icon: whatsapp
    }
];

export default contactData;
